import type {Writable} from "svelte/store";

export function containerHeight(node: HTMLElement, containerWritable: Writable<number>) {
	const resizeObserver = new ResizeObserver(() => {
		const containerHeight = node.clientHeight;
		containerWritable.set(containerHeight);
  });

  resizeObserver.observe(node);

	return {
		destroy() {
			resizeObserver.disconnect();
		},
	};
}
